import affiliateDashboard from '../../../modules/FolderAffiliateUser';
import Layout from '@/layouts/affiliate.vue';


const routes = [
    {
        path: '/affiliate-dashboard',
        component: Layout,
        children: [
            {
                path: '',
                name: 'AffiliateDashboard',
                component: affiliateDashboard,
                meta: { requiresAuth: true, role: 'affiliate' }
            }
        ],

    }
]

export default  routes ;